import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-45a2b4c2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex items-center" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "drag cursor-move" }, "⋮⋮", -1))
const _hoisted_3 = { class: "border-t mt-5 pt-3" }
const _hoisted_4 = {
  key: 1,
  class: "PaginationHolderTop"
}
const _hoisted_5 = {
  key: 0,
  class: "flex items-center"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-cog" }, null, -1))
const _hoisted_7 = { class: "flex items-center" }
const _hoisted_8 = { class: "TheTable__thead" }
const _hoisted_9 = { class: "thead__tr" }
const _hoisted_10 = {
  key: 0,
  class: "hint"
}
const _hoisted_11 = {
  key: 0,
  scope: "col",
  class: "thead__th"
}
const _hoisted_12 = { class: "TheTable__tbody" }
const _hoisted_13 = {
  key: 0,
  class: "hint"
}
const _hoisted_14 = {
  key: 1,
  class: "hint"
}
const _hoisted_15 = {
  key: 0,
  class: "tbody__td w-40"
}
const _hoisted_16 = { class: "w-full bg-white flex items-center justify-center border select-none py-3" }
const _hoisted_17 = {
  key: 0,
  class: "text-gray-400"
}
const _hoisted_18 = {
  key: 5,
  class: "PaginationHolderDown"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_checkbox = _resolveComponent("checkbox")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_modal = _resolveComponent("modal")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_new_limit = _resolveComponent("new-limit")!
  const _component_new_pagination = _resolveComponent("new-pagination")!
  const _component_loader = _resolveComponent("loader")!
  const _component_table_pagination = _resolveComponent("table-pagination")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.tablesStore.isOpen)
      ? (_openBlock(), _createBlock(_component_modal, {
          key: 0,
          class: "large",
          title: "Выберите колонки для отображения",
          onCancel: _ctx.tablesStore.toggleModal,
          onConfirm: _ctx.setColumns,
          scrollable: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_draggable, {
              class: "grid grid-cols-2 gap-3",
              list: _ctx.state.columns,
              handle: ".drag",
              "item-key": "id",
              tag: "transition-group",
              "component-data": {
                tag: 'div',
                type: 'transition-group',
                name: !_ctx.state.drag ? 'flip-list' : null,
            },
              animation: 200,
              onStart: _cache[0] || (_cache[0] = ($event: any) => (_ctx.state.drag = true)),
              onEnd: _ctx.onDragEnd
            }, {
              item: _withCtx(({ element, index }) => [
                _createElementVNode("div", _hoisted_1, [
                  _hoisted_2,
                  (_openBlock(), _createBlock(_component_checkbox, {
                    key: element.id,
                    label: element.name,
                    value: _ctx.state.columns[index].isChecked,
                    "onUpdate:value": ($event: any) => ((_ctx.state.columns[index].isChecked) = $event)
                  }, null, 8, ["label", "value", "onUpdate:value"]))
                ])
              ]),
              _: 1
            }, 8, ["list", "component-data", "onEnd"]),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_checkbox, {
                value: _ctx.isAllColumnsChecked,
                label: "Выбрать все",
                "onUpdate:value": _ctx.onAllColumnsSelect
              }, null, 8, ["value", "onUpdate:value"])
            ])
          ]),
          _: 1
        }, 8, ["onCancel", "onConfirm"]))
      : _createCommentVNode("", true),
    (_ctx.withLimit)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_ctx.$slots.buttons)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _renderSlot(_ctx.$slots, "buttons", {}, undefined, true)
              ]))
            : _createCommentVNode("", true),
          (_ctx.isColumnsModal)
            ? (_openBlock(), _createBlock(_component_the_button, {
                key: 1,
                class: "primary small mr-2",
                loading: _ctx.loading,
                onClick: _ctx.tablesStore.toggleModal
              }, {
                default: _withCtx(() => [
                  _hoisted_6
                ]),
                _: 1
              }, 8, ["loading", "onClick"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_new_limit, {
              disabled: _ctx.loading,
              value: _ctx.paginationLimit,
              "total-items": _ctx.paginationTotalItems,
              loading: _ctx.quantityLoading,
              onChange: _ctx.emitChangeLimit
            }, null, 8, ["disabled", "value", "total-items", "loading", "onChange"]),
            _createVNode(_component_new_pagination, {
              class: "ml-6",
              disabled: _ctx.loading,
              "current-page": _ctx.paginationCurrentPage,
              "total-pages": _ctx.paginationTotalPages,
              onChangePage: _ctx.emitChangePage
            }, null, 8, ["disabled", "current-page", "total-pages", "onChangePage"])
          ])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.loading && _ctx.rows.length)
      ? (_openBlock(), _createElementBlock("table", {
          key: 2,
          class: _normalizeClass(['TheTable', { WithLimit: _ctx.withLimit }]),
          border: "1",
          cellpadding: "0",
          cellspacing: "0"
        }, [
          _createElementVNode("thead", _hoisted_8, [
            _createElementVNode("tr", _hoisted_9, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredColumns, (column, i) => {
                return (_openBlock(), _createElementBlock("th", {
                  scope: "col",
                  class: "thead__th",
                  key: `TableRow-${i}`
                }, [
                  _createTextVNode(_toDisplayString(column.name) + " ", 1),
                  (column.headerHint)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(column.headerHint), 1))
                    : _createCommentVNode("", true)
                ]))
              }), 128)),
              (_ctx.$slots.actions)
                ? (_openBlock(), _createElementBlock("th", _hoisted_11))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("tbody", _hoisted_12, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rows, (row, i) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: `TableRow-${i}`,
                class: _normalizeClass(['tbody__tr', { tbody__tr__blue: row.isBlue, tbody__tr__red: row.isRed }])
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredColumns, (column, j) => {
                  return (_openBlock(), _createElementBlock("td", {
                    key: `TableTd-${i}-${j}`,
                    class: _normalizeClass(['tbody__td', { 'whitespace-nowrap': !_ctx.isWrap }])
                  }, [
                    (_ctx.$slots.td)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _renderSlot(_ctx.$slots, "td", {
                            row: row,
                            column: column,
                            index: j,
                            key: `${i}-${j}`
                          }, undefined, true),
                          (column.withHint && row[column.key])
                            ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(row[column.key]), 1))
                            : (column.customHint && row[column.key])
                              ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(row[column.key][column.customHint]), 1))
                              : _createCommentVNode("", true)
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(_toDisplayString(row[column.key]), 1)
                        ], 64))
                  ], 2))
                }), 128)),
                (_ctx.$slots.actions)
                  ? (_openBlock(), _createElementBlock("td", _hoisted_15, [
                      _renderSlot(_ctx.$slots, "actions", { row: row }, undefined, true)
                    ]))
                  : _createCommentVNode("", true)
              ], 2))
            }), 128))
          ])
        ], 2))
      : _createCommentVNode("", true),
    (!_ctx.rows.length || _ctx.loading)
      ? (_openBlock(), _createElementBlock("div", {
          key: 3,
          class: _normalizeClass({ WithLimit: _ctx.withLimit })
        }, [
          _createElementVNode("div", _hoisted_16, [
            (!_ctx.loading)
              ? (_openBlock(), _createElementBlock("p", _hoisted_17, "Нет данных"))
              : (_openBlock(), _createBlock(_component_loader, {
                  key: 1,
                  class: "primary"
                }))
          ])
        ], 2))
      : _createCommentVNode("", true),
    (_ctx.pagination)
      ? (_openBlock(), _createBlock(_component_table_pagination, {
          key: 4,
          currentPage: _ctx.paginationCurrentPage,
          totalItems: _ctx.paginationTotalItems,
          totalPages: _ctx.paginationTotalPages,
          limit: _ctx.paginationLimit,
          onChange: _ctx.emitChangePage
        }, null, 8, ["currentPage", "totalItems", "totalPages", "limit", "onChange"]))
      : _createCommentVNode("", true),
    (_ctx.withLimit)
      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
          _createVNode(_component_new_limit, {
            disabled: _ctx.loading,
            value: _ctx.paginationLimit,
            "total-items": _ctx.paginationTotalItems,
            loading: _ctx.quantityLoading,
            onChange: _ctx.emitChangeLimit
          }, null, 8, ["disabled", "value", "total-items", "loading", "onChange"]),
          _createVNode(_component_new_pagination, {
            class: "ml-6",
            disabled: _ctx.loading,
            "current-page": _ctx.paginationCurrentPage,
            "total-pages": _ctx.paginationTotalPages,
            onChangePage: _ctx.emitChangePage
          }, null, 8, ["disabled", "current-page", "total-pages", "onChangePage"])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}